import { render } from "./SeoParentVariationTheme.vue?vue&type=template&id=2115dbf2&scoped=true"
import script from "./SeoParentVariationTheme.vue?vue&type=script&lang=js"
export * from "./SeoParentVariationTheme.vue?vue&type=script&lang=js"

import "./SeoParentVariationTheme.vue?vue&type=style&index=0&id=2115dbf2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2115dbf2"]])

export default __exports__